import parseFontSizeToPx from '../../helpers/typography';
import {
  ITAU_FONT_TEXT,
  ITAU_FONT_DISPLAY,
  ITAU_FONT_SIZE_THRESHOLD,
  ITAU_BASE_FONT_SIZE,
} from './fonts';

const MEDIA_QUERY_PREFIX = '@media';

export const getItauFontFamily = (fontSize, fallbackSize = ITAU_BASE_FONT_SIZE) => {
  const px = parseFontSizeToPx(fontSize, fallbackSize, ITAU_BASE_FONT_SIZE);
  return px >= ITAU_FONT_SIZE_THRESHOLD ? ITAU_FONT_DISPLAY : ITAU_FONT_TEXT;
};

const applyFontFamilyToStyle = (style, fallbackSize = ITAU_BASE_FONT_SIZE) => {
  if (!style || typeof style !== 'object') {
    return style;
  }

  const nextStyle = { ...style };

  if (nextStyle.fontSize !== undefined) {
    nextStyle.fontFamily = getItauFontFamily(nextStyle.fontSize, fallbackSize);
  }

  Object.entries(nextStyle).forEach(([key, value]) => {
    if (key.startsWith(MEDIA_QUERY_PREFIX) && value && typeof value === 'object') {
      const mediaFallbackSize = parseFontSizeToPx(
        nextStyle.fontSize,
        fallbackSize,
        ITAU_BASE_FONT_SIZE,
      );
      nextStyle[key] = applyFontFamilyToStyle(value, mediaFallbackSize);
    }
  });

  return nextStyle;
};

export const applyItauFontFamilies = (typography) => {
  const result = { ...typography };

  Object.entries(result).forEach(([key, value]) => {
    if (typeof value !== 'object' || value === null) {
      return;
    }

    result[key] = applyFontFamilyToStyle(value);
  });

  return result;
};
